import { createApiRef } from '@backstage/core-plugin-api';
import type { PrometheusQuery, DataFrameResult, TimeRange, GrafanaAlert, LogEntry } from './types';

/** API for querying Grafana datasources via the Backstage proxy */
export interface GrafanaQueryApi {
  /** Execute one or more PromQL queries via Grafana's unified query endpoint */
  queryPrometheus(
    queries: PrometheusQuery[],
    timeRange: TimeRange,
  ): Promise<DataFrameResult>;

  /** Fetch label values from Prometheus for populating filter dropdowns */
  queryLabelValues(
    label: string,
    matchers?: string,
  ): Promise<string[]>;

  /** Fetch Grafana unified alerting rules filtered by label matcher */
  queryAlerts(labelSelector: string): Promise<GrafanaAlert[]>;

  /** Query Loki logs via Grafana's datasource query endpoint */
  queryLoki(
    logql: string,
    timeRange: TimeRange,
    limit?: number,
  ): Promise<LogEntry[]>;
}

export const grafanaQueryApiRef = createApiRef<GrafanaQueryApi>({
  id: 'plugin.grafana-dashboard.service',
});
